/**
 * Race configuration — single source of truth.
 *
 * Change RACE_ID to point this app at any yb.tl race. It is imported by the
 * browser app (src/data/raceData.js), the Cloudflare Worker (src/worker.js),
 * and the binary encoder script (scripts/encode-race-data.cjs).
 *
 * The slug is the segment in the yb.tl URL, e.g. https://yb.tl/<RACE_ID>
 */
export const RACE_ID = 'nb2026';

/**
 * Display strings for the current race. The yb.tl API only exposes the slug,
 * so the human-facing title/route live here. Set RACE_ROUTE to '' to hide the
 * course subtitle for races without a fixed start → finish.
 */
export const RACE_TITLE = 'NB 2026';
export const RACE_ROUTE = '';

/**
 * Build the yb.tl positions API URL for a given race.
 */
export function buildApiUrl(raceId = RACE_ID) {
  return `https://yb.tl/API3/Race/${raceId}/GetPositions?n=9999`;
}
